
import { Music, Calendar, DollarSign, MessageSquare } from "lucide-react";
import { DashboardFeature } from "./types";

export const performerFeatures: DashboardFeature[] = [
  {
    icon: Music,
    title: "Performance Profile",
    description: "Manage your performance profile",
    href: "/dashboard/performer/profile",
  },
  {
    icon: Calendar,
    title: "Performance Calendar",
    description: "View and manage your performances",
    href: "/dashboard/performer/gigs",
  },
  {
    icon: DollarSign,
    title: "Earnings",
    description: "Track your earnings",
    href: "/dashboard/performer/earnings",
  },
  {
    icon: MessageSquare,
    title: "Booking Requests",
    description: "Manage booking requests",
    href: "/dashboard/performer/bookings",
  }
];
